module.exports = "/ui/b8b7dcee0140e2e735aef53208c119cd.png";